import { fromJS } from 'immutable';
import {
  NAVIGATE_TO_CD,
  NAVIGATE_TO_BD,
  USERNAME_PASSWORD,
  PAYMENT_TYPE_CHECKBOX,
  INITIAL_INFO,
  CASE_ID,
  ACCOUND_DETAILS,
  PERSONAL_INFO,
  MANDATE_INFO,
  BUSINESS_TYPE_PAGE,
  ADDITIONAL_PRODUCT,
  NAVIGATE_TO_CD_REVIEW,
  INITIAL_QUESTIONS_TMSP,
  NAVIGATE_TO_BD_REVIEW,
  CREATE_CASE_ERROR,
  LINK_CODE_DETAIL,
  CREATE_CUSTOMERS_CASE_SUCCESS,
  CREATE_CUSTOMERS_CASE_FAILED,
  SIGNATORIES_SHAREHOLDER_DATA,
  BUSINESS_TYPE_FIELD,
  OFFER_CASE_ID
} from '../../utils/constants';
import {
  SAVE_USERNAME_PASSWORD_FORM,
  SAVE_PERSONAL_INFORMATION_FORM,
  PAYMENT_TYPE_CHECKBOX_CHECKED,
  SAVE_ACCOUNT_DETAILS_PAGE,
  SAVE_BUSINESS_TYPE_FORM,
  SAVE_ADDITIONAL_PRODUCTS_FORM,
  SAVE_INITIAL_QUESTIONS_FORM,
  SAVE_DETAILS_FORM,
  FETCH_USER_SUCCESS,
  SAVE_BUSINESS_MANDATE_PAGE,
  SAVE_BUSINESS_MANDATE_FORM,
  SAVE_ENTER_LINK_CODE_FORM,
  ON_ACCOUNT_DETAILS_CHANGE,
  SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM,
  ON_COUNTRY_REMOMVE,
  SUBMIT_CASE_ID_FORM_SUCCESS,
  RESET_LINK_CODE_ERROR,
  SUBMIT_EVIDENCE_INFO_FORM,
  SUBMIT_EVIDENCE_INFO_SUCCESS,
  SUBMIT_EVIDENCE_INFO_FAILED
} from './actions';
import { FETCH_CASE_SUCCESS } from '../../infrastructure/cases/actions';
import { FETCH_CUSTOMERBYID_SUCCESS } from '../../infrastructure/customers';
import { ERROR_CODES, ERROR_CODE_325, ERROR_CODE_326 } from '../../utils/errorCodes';
import { isEmpty, getQueryStringValueByName } from '../../utils';
import { PAYMENT_TRANSFER } from '../../routes/accountDetailsSection/accoundDetailsUtil';
import { INITIAL_SCREEN_DATA } from '../../store/dataCapture/initialScrensData';
import * as analytics from '../../utils/analytics';
export const initialState = fromJS({
  loading: false,
  showLoader: true,
  showLoadingScreen: false
});
const mapAccountDetails = data =>
  data
    ? {
        annualTurnover: data.account_approx_annual_turnover,
        paymentOfType: data.account_payment_types,
        howPaymentMade: data.account_payment_frequency,
        cashDeposit: data.annual_cash_deposits,
        accountDetailsPayment: data.international_payment,
        send_payments: getCountries(data.international_payment_countries.send_payments),
        receive_payments: getCountries(data.international_payment_countries.receive_payments),
        paymentCameFrom: data.account_payment_sources
      }
    : '';
const getCountries = data => {
  const accountData =
    data && data.length > 0 ? data.filter(v => isEmpty(v.country_of_payment)) : [];

  return accountData && accountData.length > 0
    ? accountData.map(item => {
        return { [`${item.country_of_payment}`]: item.turnover_percentage };
      })
    : [];
};
/* eslint-disable complexity */
export default function saveFormData(state = initialState, action) {
  switch (action.type) {
    case NAVIGATE_TO_CD:
    case NAVIGATE_TO_CD_REVIEW:
      return state;
    case NAVIGATE_TO_BD:
      return state.set(CASE_ID, action.data.case_id);
    case NAVIGATE_TO_BD_REVIEW:
      return state.set('loading', true);
    case SAVE_INITIAL_QUESTIONS_FORM:
      analytics.updateBusinessType(action.data.businessTypeField);
      return state
        .set(INITIAL_INFO, fromJS(action.data))
        .set(INITIAL_QUESTIONS_TMSP, new Date().toISOString());
    case SAVE_PERSONAL_INFORMATION_FORM:
      return state.set(PERSONAL_INFO, fromJS(action.data));
    case SAVE_BUSINESS_MANDATE_PAGE:
    case SAVE_BUSINESS_MANDATE_FORM:
      return state.set(MANDATE_INFO, fromJS(action.data));
    case SAVE_ADDITIONAL_PRODUCTS_FORM:
      return state.set(ADDITIONAL_PRODUCT, fromJS(action.data));
    case SAVE_BUSINESS_TYPE_FORM:
      return state.set(BUSINESS_TYPE_PAGE, fromJS(action.data));
    case FETCH_USER_SUCCESS:
      return state.set(USERNAME_PASSWORD, getUserDetails(action.payload.user_name));
    case SAVE_USERNAME_PASSWORD_FORM:
      return state.set(USERNAME_PASSWORD, action.data);
    case SAVE_ACCOUNT_DETAILS_PAGE:
      return state.set(ACCOUND_DETAILS, fromJS(action.data));
    case SAVE_DETAILS_FORM:
      return state.set(ACCOUND_DETAILS, fromJS(action.data));
    case PAYMENT_TYPE_CHECKBOX_CHECKED:
      return state.set(PAYMENT_TYPE_CHECKBOX, action.data);
    case FETCH_CASE_SUCCESS:
      return state
        .set(ACCOUND_DETAILS, fromJS(mapAccountDetails(action.payload.business_account)))
        .set('caseData', action.payload)
        .set(
          INITIAL_INFO,
          fromJS(INITIAL_SCREEN_DATA).set(
            BUSINESS_TYPE_FIELD,
            fromJS(action.payload.product ? action.payload.product.variant : '')
          )
        )
        .set(MANDATE_INFO, fromJS(mapBusinessMandareData(action.payload)))
        .set(
          ADDITIONAL_PRODUCT,
          fromJS({
            additionalProductsInterestedField: getAdditionalProducts(action.payload)
          })
        );
    case `${USERNAME_PASSWORD}${FETCH_CUSTOMERBYID_SUCCESS}`:
      return getQueryStringValueByName(CASE_ID) || getQueryStringValueByName(OFFER_CASE_ID)
        ? state
        : state.set(
            USERNAME_PASSWORD,
            getUserDetails(
              action.payload &&
                action.payload.contact_details &&
                action.payload.contact_details.email
                ? action.payload.contact_details.email.toLowerCase()
                : ''
            )
          );
    case CREATE_CUSTOMERS_CASE_FAILED:
      return state.set(CREATE_CASE_ERROR, getCreateCaseErrors(action.meta));
    case CREATE_CUSTOMERS_CASE_SUCCESS:
      return state.set(CREATE_CASE_ERROR, '');
    case SAVE_ENTER_LINK_CODE_FORM:
      return state.set(LINK_CODE_DETAIL, action.data);
    default:
      return processRemainingActions(action, state);
  }
}
const processRemainingActions = (action, state) => {
  switch (action.type) {
    case RESET_LINK_CODE_ERROR:
      return state.set(CREATE_CASE_ERROR, '');
    case ON_ACCOUNT_DETAILS_CHANGE:
      return onAccountDetailsChange(state, action.data);
    case SUBMIT_CASE_ID_FORM_SUCCESS:
      return state.set('showLoader', false);
    case SUBMIT_EVIDENCE_INFO_FORM:
      return state.set('showLoadingScreen', action.meta.isFromPage);
    case ON_COUNTRY_REMOMVE:
      return onCountryRemove(state, action.data);
    case SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM:
      return state.set(SIGNATORIES_SHAREHOLDER_DATA, fromJS(action.values));
    case 'GET_NEXT_CALL_SUCCESS':
    case 'GET_NEXT_CALL_FAILED':
      return state.set('showLoadingScreen', false);
    default:
      return state;
  }
};
const onAccountDetailsChange = (state, data) => {
  let details = state.get(ACCOUND_DETAILS);
  details = details && details.toJS ? details.toJS() : details;
  if (details) {
    switch (data.target.value) {
      case PAYMENT_TRANSFER.NO_INTENTION:
      case PAYMENT_TRANSFER.MAKE_PAYMENTS:
      case PAYMENT_TRANSFER.RECEIVE_PAYMENTS:
      case PAYMENT_TRANSFER.MAKE_AND_RECEIVE_PAYMENTS:
        details.send_payments = [];
        details.receive_payments = [];
        details.accountDetailsPayment = data.target.value;
        break;
      default:
        return state;
    }
    return state.set(ACCOUND_DETAILS, fromJS(details));
  }
  return state;
};

const onCountryRemove = (state, data) => {
  let details = state.get(ACCOUND_DETAILS);
  details = details && details.toJS ? details.toJS() : details;
  if (details && data) {
    return state.set(ACCOUND_DETAILS, fromJS(data));
  }
  return state;
};

const getUserDetails = username => {
  return {
    username: username,
    password: ''
  };
};

const getCreateCaseErrors = meta => {
  if (meta.errorCode === ERROR_CODE_325 || meta.errorCode === ERROR_CODE_326) {
    return ERROR_CODES[meta.errorCode](meta.url, meta.content.toJS().external_content);
  }
  return meta.errorCode ? ERROR_CODES[meta.errorCode](meta.content.toJS().external_content) : '';
};

const getAdditionalProducts = data => {
  return data && data.sales_leads
    ? data.sales_leads.map(v => v.product_name).filter(v => v !== '')
    : [];
};
const mapBusinessMandareData = data => (data && data.business_mandate ? data.business_mandate : {});
